import { tns } from 'tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';

class Page {
    // this method is called via HTMX hx-get and hx-on::after-request
    eventsCarousel() {
        tns({
            container: '.events-carousel__slider',
            controlsContainer: '#events-slider-controls',
            items: 1,
            slideBy: 1,
            autoplay: false,
            autoplayTimeout: 8000,
            autoplayButtonOutput: false,
            autoWidth: false,
            arrowKeys: true,
            controls: false,
            edgePadding: 0,
            fixedWidth: false,
            gutter: 5,
            mouseDrag: true,
            nav: true,
            navPosition: 'bottom',
            responsive: {
                550: {
                    items: 2,
                    controls: true
                },
                900: {
                    items: 3,
                    controls: true
                }
            }
        });
    }
}

window.addEventListener('DOMContentLoaded', () => {
    (<any>window).page = new Page();
});
